var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-list"},[_c('ListHeader',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"tag-chips flex wrap"},_vm._l((_vm.tags),function(tag){return _c('TagChip',{key:tag.name,attrs:{"name":tag.name}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }